import React from "react";
import { Hero } from "../components/home/Hero";
import { UspBar } from "../components/home/UspBar";
import { CategoryCards } from "../components/home/CategoryCards";
import { FeaturedProducts } from "../components/home/FeaturedProducts";
import { ShopTheLook } from "../components/home/ShopTheLook";
import { StudioStory } from "../components/home/StudioStory";
import { PromoBanners } from "../components/home/PromoBanners";
import { CustomBand } from "../components/home/CustomBand";
export function Home() {
  return <>
      <Hero data-id="element-500" data-mp="24hk83ft75nlw" />
      <UspBar data-id="element-501" data-mp="24haeli8y0ybg" />
      <CategoryCards data-id="element-502" data-mp="24ivbheiqctch" />
      <FeaturedProducts data-id="element-503" data-mp="29gdekoa2geck" />
      <ShopTheLook data-id="element-504" data-mp="29f264b5oeif4" />
      <StudioStory data-id="element-505" data-mp="29ek6d4jt1m2g" />
      <PromoBanners data-id="element-506" data-mp="29ihpvraaofmv" />
      <CustomBand data-id="element-507" data-mp="2dhgsh58k00b5" />
    </>;
}